import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumbs.css';

function Breadcrumbs({
  gameName,
  gamePath,
  categoryName = 'Logic Games',
  categoryPath = '/logic-games',
  currentLabel,
}) {
  const label = currentLabel || `Play ${gameName}`;
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb navigation">
      <ol className="breadcrumb-list">
        <li className="breadcrumb-item">
          <Link to="/" className="breadcrumb-link">
            Home
          </Link>
        </li>
        <li className="breadcrumb-separator" aria-hidden="true">›</li>
        <li className="breadcrumb-item">
          <Link to={categoryPath} className="breadcrumb-link">
            {categoryName}
          </Link>
        </li>
        <li className="breadcrumb-separator" aria-hidden="true">›</li>
        <li className="breadcrumb-item breadcrumb-current" aria-current="page">
          <span>{label}</span>
        </li>
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
